import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { DropTarget } from "react-dnd";
import { NativeTypes } from "react-dnd-html5-backend";
import { lighten } from "polished";
import { H2 } from "./Heading";
import Attachment from "./Attachment";
import Icon from "./Icon";
import * as colors from "../settings/colors";
import { CLOUD_UPLOAD } from "../icons";

const sectionTarget = {
  drop(props, monitor) {
    if (props.onDrop) {
      props.onDrop(props, monitor);
    }
  }
};

const UploadIcon = styled(Icon)`
  position: absolute;
  right: 0;
  cursor: pointer;

  &:hover {
    color: ${colors.TAB_ACTIVE_TEXT};
  }
`;

const activeBorderColor = lighten(0.2, colors.BLUE);

// prettier-ignore
const DropBox = styled.div`
  color: ${colors.TEXT_SECONDARY};
  font-size: 16px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 140px;
  margin: 8px 0;
  border: 3px dashed ${colors.DIVIDER};
  border-radius: 20px;
  cursor: pointer;

  &:before {
    content: "Drop your files here";
  }

  &:hover {
    color: ${colors.BLUE};
    border-color: ${activeBorderColor};
  }

  &:hover:before {
    content: "Click to select files";
  }
`;

const AttachmentsContainer = styled.div([]);

class AttachmentsSection extends React.Component {
  renderAttachments = () => {
    const { attachments } = this.props;

    if (!attachments.length) {
      return <DropBox onClick={this.props.onClick} />;
    } else {
      return (
        <AttachmentsContainer>
          {attachments.map(attachment => (
            <Attachment
              key={attachment.id}
              attachment={attachment}
              deleteAttachment={this.props.deleteAttachment}
              match={this.props.match}
              history={this.props.history}
            />
          ))}
        </AttachmentsContainer>
      );
    }
  };

  render() {
    const { connectDropTarget, className } = this.props;

    return connectDropTarget(
      <div className={className}>
        <H2 style={{ position: "relative" }}>
          {this.props.title}
          <UploadIcon icon={CLOUD_UPLOAD} onClick={this.props.onClick} />
        </H2>
        {this.renderAttachments()}
      </div>
    );
  }

  static propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    attachments: PropTypes.array,
    deleteAttachment: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    isOver: PropTypes.bool.isRequired,
    canDrop: PropTypes.bool.isRequired,
    match: PropTypes.object,
    history: PropTypes.object,
    onDrop: PropTypes.func
  };
}

// prettier-ignore
const StyledAttachmentsSection = styled(AttachmentsSection)`
  margin-bottom: 16px;

  ${props => props.required && css`
    & ${H2} {
      color: ${colors.ORANGE};
    }

    & ${DropBox} {
      color: ${colors.ORANGE};
      border-color: ${lighten(0.2, colors.ORANGE)};
    }
  `};

  ${props => props.canDrop && props.isOver && css`
    & ${H2} {
      color: ${colors.BLUE};
    }

    & ${AttachmentsContainer},
    & ${DropBox} {
      background: ${lighten(0.5, colors.BLUE)};
    }

    & ${DropBox} {
      color: ${colors.BLUE};
      border-color: ${activeBorderColor};
    }
  `};
`;

export default DropTarget(
  [NativeTypes.FILE],
  sectionTarget,
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  })
)(StyledAttachmentsSection);



// WEBPACK FOOTER //
// ./src/components/AttachmentsSection.js